module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "term"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Ошибка Получения данных!")]) : _vm._e(), _vm._v(" "), (_vm.pager) ? _c('nav', {
    attrs: {
      "id": "pager-block"
    }
  }, [_c('ul', {
    staticClass: "pager"
  }, [(_vm.pager.prev.id) ? _c('li', {
    staticClass: "previous"
  }, [_c('a', {
    attrs: {
      "href": '#/term/' + _vm.pager.prev.id
    }
  }, [_c('span', {
    staticClass: "fa fa-arrow-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.pager.prev.term))])]) : _vm._e(), _vm._v(" "), (_vm.pager.next.id) ? _c('li', {
    staticClass: "next"
  }, [_c('a', {
    attrs: {
      "href": '#/term/' + _vm.pager.next.id
    }
  }, [_vm._v(_vm._s(_vm.pager.next.term) + " "), _c('span', {
    staticClass: "fa fa-arrow-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.content) ? _c('div', {
    staticClass: "success"
  }, [_c('div', {
    staticClass: "panel panel-default margin-bottom"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.content.word_orig))]), _vm._v(" "), _c('small', [_vm._v("[" + _vm._s(_vm.content.volume) + " : " + _vm._s(_vm.content.fpage)), (_vm.content.fpage !== _vm.content.lpage) ? _c('span', [_vm._v(" - " + _vm._s(_vm.content.lpage))]) : _vm._e(), _vm._v("]")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-justify",
    domProps: {
      "innerHTML": _vm._s(_vm.content.word_desc)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.content.word_desc) + "                  \n                ")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-default btn-xs pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#infoModal",
      "title": "Сообщить об ошибке!"
    }
  }, [_c('span', {
    staticClass: "fa fa-exclamation-triangle text-danger",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c267217"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Term.vue
// module id = 29
// module chunks = 0